import { createThemedComponent, withTheme } from "@vitalsource/vstui/themes";
import { Button } from "@vitalsource/vstui";
import React from "react";
import { eggplant } from "@vitalsource/vstui/colors";

const createBadgeButton = (color, minHeight, theme) => 
  createThemedComponent(Button, {
    Button_borderRadius: "100px",
    Button_minHeight_small: minHeight || theme.vstui.size.small,
    Button_backgroundColor_themePrimary: color.getShade(7),
    Button_backgroundColor_themePrimary_active: color.getShade(9),
    Button_backgroundColor_themePrimary_focus: color.getShade(9),
    Button_backgroundColor_themePrimary_hover: color.getShade(9),
    Button_borderColor_themePrimary: color.getShade(7),
    Button_borderColor_themePrimary_active: color.getShade(9),
    Button_borderColor_themePrimary_focus: color.getShade(9),
    Button_borderColor_themePrimary_hover: color.getShade(9)
  });

class BadgeButton extends React.Component {
  constructor(props) {
    super(props);
    this.customButton = createBadgeButton(
      this.props.color,
      this.props.minHeight,
      this.props.theme,
    );
  }

  // TODO: Re-generate button if color changes
  render() {
    const { color, ...restProps } = this.props;
    return <this.customButton {...restProps} />;
  }
}

BadgeButton.defaultProps = {
  color: eggplant
};

export default withTheme(BadgeButton);
